export default __webpack_public_path__ + "static/media/28.a0b5767f.png";